/* DrillDown CSS Module */

/* ============================================
   Container - main wrapper
   ============================================ */
.container {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

/* ============================================
   Title Container - header area
   ============================================ */
.titleContainer {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: var(--spaces-12);
}

/* ============================================
   Primary Title Container - centered title
   ============================================ */
.primaryTitleContainer {
  align-items: center;
  display: flex;
  justify-content: center;
  left: 0;
  padding-left: var(--spaces-48);
  padding-right: var(--spaces-48);
  pointer-events: none;
  position: absolute;
  width: 100%;

  /* Transition */
  transition-duration: var(--transitions-durations-300);
  transition-property: transform, opacity, visibility;
  transition-timing-function: var(--transitions-eases-primary);

  @media (prefers-reduced-motion: reduce) {
    transition-property: opacity, visibility;
  }
}

/* ============================================
   Back Label Container - back text area
   ============================================ */
.backLabelContainer {
  padding-left: var(--spaces-4);
  width: 100%;

  /* Transition */
  transition-duration: var(--transitions-durations-300);
  transition-property: transform, opacity, visibility;
  transition-timing-function: var(--transitions-eases-primary);

  @media (prefers-reduced-motion: reduce) {
    transition-property: opacity, visibility;
  }
}

/* ============================================
   Content - columns container
   ============================================ */
.content {
  flex: 1;
  overflow: hidden;
  position: relative;
  width: 100%;
}

/* ============================================
   Column - individual column
   ============================================ */
.column {
  bottom: 0;
  height: 100%;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  will-change: transform, opacity;

  /* Transition */
  transition-duration: var(--transitions-durations-300);
  transition-property: transform, opacity, visibility;
  transition-timing-function: var(--transitions-eases-primary);

  @media (prefers-reduced-motion: reduce) {
    transition-property: opacity, visibility;
  }
}

/* ============================================
   Back Button - icon button wrapper
   ============================================ */
.backButton {
  /* Transition */
  transition-duration: var(--transitions-durations-300);
  transition-property: transform, opacity, visibility;
  transition-timing-function: var(--transitions-eases-primary);

  @media (prefers-reduced-motion: reduce) {
    transition-property: opacity, visibility;
  }
}

/* ============================================
   Panel Actions - right-side actions
   ============================================ */
.panelActions {
  will-change: transform;

  /* Transition */
  transition-duration: var(--transitions-durations-300);
  transition-property: transform, opacity, visibility;
  transition-timing-function: var(--transitions-eases-primary);

  @media (prefers-reduced-motion: reduce) {
    transition-property: opacity, visibility;
  }
}
